import { CarIcon } from './CarIcon';

/**
 * author: Google
 * id FCF4FF57-4547-4C11-A20A-3D26252780EC
 * name car
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car.svg
 * tags
 * - Transportation + Road 
 * - Navigation 
 * - Automotive 
 */
export const DirectionsCarIcon = CarIcon;
export default DirectionsCarIcon